import { ConceptNodeMap } from "../../Concepts.interface";
import { getAllDescendants } from "./getAllDescendants";
import { compressImplicitSelection } from "./compressImplicitSelection";

export const selectNode = (
  id: string,
  selected: Set<string>,
  treeMap: ConceptNodeMap,
) => {
  const newSet = new Set(selected);

  newSet.add(id);
  getAllDescendants(id, treeMap).forEach((desc) => newSet.add(desc));

  return compressImplicitSelection(newSet, treeMap);
};
